var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-col",
    { attrs: { tag: "a", sm: "6", md: "4", href: _vm.href } },
    [
      _c(
        "b-card",
        {
          attrs: { "header-class": "aspect-1-1" },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c("div", { staticClass: "aspect-box" }, [
                    _c("img", {
                      attrs: { src: `${_vm.product.images[0].src}.jpg` },
                    }),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("b-overlay", { attrs: { show: _vm.loading } }, [
            _c("span", [_vm._v(_vm._s(_vm.product.name))]),
            _c("small", [
              _vm._v("For £" + _vm._s(_vm.priceIncrease) + " more each"),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }